module.exports = __webpack_public_path__ + "static/media/slide_5.dd3b4503.jpg";